export type CustomAttributes = Record<string, unknown>;

export enum MonitoredEventTypes {
  ACTION = "action",
  TIMING = "timing",
  WARNING = "warning",
}
